export default {
  applyToVersions: "<2.6.0",
  type: "before",
  name: "rename view stores",
  migrate(data) {
    if (data.evaluationView) {
      return data;
    }

    data.evaluationView = data.evaluation;
    data.inspectorView = data.inspector;
    data.variablesView = data.variables;
    data.simulationView = data.simulation;

    delete data.evaluation;
    delete data.inspector;
    delete data.variables;
    delete data.simulation;

    return data;
  }
};
